import {
    FETCH_FAULT_BY_PRIORITY,
    FETCH_FAULT_BY_RULE,
    FETCH_WORST_PERFORMING_EQUIPMENT,
    FETCH_SITE_SCORE_DATA
} from '../actions/actionTypes';

const initialState = {
    faults:                       [],
    faultsMeta:                   {},
    ruleFaults:                   [],
    ruleFaultsMeta:               {},
    worstPerformingEquipment:     [],
    worstPerformingEquipmentMeta: {},
    sites:                        [],
    sitesMeta:                    {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FAULT_BY_PRIORITY:
            return {
                ...state,
                faults:     [...action.payload.data],
                faultsMeta: {...action.payload.meta}
            };
        case FETCH_FAULT_BY_RULE:
            return {
                ...state,
                ruleFaults:     [...action.payload.data],
                ruleFaultsMeta: { ...action.payload.meta}
            };
        case FETCH_SITE_SCORE_DATA:
            return {
                ...state,
                sites:     [...action.payload.data],
                sitesMeta: {...action.payload.meta}
            };
        case FETCH_WORST_PERFORMING_EQUIPMENT:
            return {
                ...state,
                worstPerformingEquipment:     [...action.payload.data],
                worstPerformingEquipmentMeta: { ...action.payload.meta }
            };
        default:
            return state;
    }
};
